import { Video } from 'lucide-react';

import type { ScriptElement, VideoContent } from '@/lib/schema.types';

export function VideoElement({ element, autoPlay }: { element: ScriptElement; autoPlay?: boolean }) {
  const c = element.content as VideoContent | undefined;
  if (!c?.src) {
    return (
      <div className="flex aspect-video w-full items-center justify-center rounded-md bg-black/5 text-fg-subtle">
        <Video size={20} />
      </div>
    );
  }
  return (
    <video
      // key on autoPlay so entering preview re-mounts the element and plays.
      key={autoPlay ? 'play' : 'idle'}
      src={c.src}
      poster={c.poster}
      controls
      autoPlay={autoPlay}
      className="block aspect-video w-full rounded-md"
    />
  );
}
